import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import agradecimiento from 'assets/img/agradecimiento.svg';
import flujoagradecimiento from 'assets/img/youtube40x25.png';

const MyGuestsGratitude = () => {

    return (
        <div className="col-md-12" style={{ marginTop: '10px', padding: '15px' }}>
            <div className="d-flex align-items-center">
                <div>
                    <img src={agradecimiento} style={{ width: '80px', height: '80px' }} alt="Agradecimientos" />
                </div>
                <div className="ml-3 flex-grow-1">
                    <div>
                        <b>Agradecimientos</b>
                    </div>
                    <div className="mb-2">
                        <p className="mb-0">Envía a tus invitados una<br />tarjeta de agradecimiento</p>
                    </div>
                </div>
                <div className="ml-auto d-flex">
                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                </div>
            </div>
        </div>
    );
}

export default MyGuestsGratitude;